export default "__VITE_ASSET__ca5cd596__"